import { Injectable } from '@angular/core';
import { ServiceApi } from '../genericApi/service-api';
import { ConfigService } from '../../Core/Config/services/config.service';
import { ConfigModel } from '../../Core/Config/models/config.model';
import { Observable } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { SearchContactsAndOutletsApiModel } from './model/search-contacts-and-outlets-api.model';
import { SearchContactsAndOutletsResponseApiModel } from './model/search-contacts-and-outlets-response-api.model';

@Injectable()
export class JournodexSearchesApi {
    private apiUrl: string;

    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService
    ) {
        const config: ConfigModel = this.configurationService.getConfig();

        this.apiUrl = config.apiUrl;
    }

    public searchContactsAndOutlets(search: SearchContactsAndOutletsApiModel): Observable<SearchContactsAndOutletsResponseApiModel[]> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<SearchContactsAndOutletsResponseApiModel[]>(
            '/journodex-searches/searchContactsAndOutlets',
            search,
            HttpVerbsEnum.POST
        );
    }
}
